// eslint-disable-next-line import/no-cycle
import ajax from '../../../../scanline/utils/ajax';

const MapsUtil = {
	vectorTile(app, layer, coords, callback) {
		ajax(
			'/vectorTile',
			JSON.stringify({ app, layer, coords }),
			'POST',
			callback,
			false,
			'maps'
		);
	},
	imageTile(app, layer, coords, callback) {
		ajax(
			'/imageTile',
			JSON.stringify({ app, layer, coords }),
			'POST',
			callback,
			false,
			'maps'
		);
	},
	access(app, callback) {
		ajax('/access', JSON.stringify({ app }), 'POST', callback, false, 'maps');
	},
	image(app, layer, coords, size, selected, searches, callback) {
		ajax(
			'/image',
			JSON.stringify({ app, layer, coords, size, selected, searches }),
			'POST',
			callback,
			false,
			'maps'
		);
	},
	markermap(x, y, height = 300, width = 300, bbox = null) {
		const body = { x, y, height, width };
		if (Array.isArray(bbox) && bbox.length === 4) {
			body.bbox = bbox;
		}
		return ajax(
			'/markermap',
			JSON.stringify(body),
			'POST',
			undefined,
			false,
			'maps'
		);
	}
};

export default MapsUtil;
